import React, { useMemo } from "react";
import cx from "classnames";
import { Field } from "formik";
import { RadioInput } from "components/Inputs/FormikInputs/RadioInput";
import { CheckboxInput } from "components/Inputs/FormikInputs/CheckboxInput";
import { FormikNumberInput, FormSelect, TextInput } from "components/Inputs";
import { Icon } from "components";
import s from "../../WizardQuestionnaire.module.scss";

export const ContentByField = ({
  field: {
    fieldDefaultValue,
    fieldInputType,
    fieldKey,
    fieldType,
    title,
    fieldMin,
    fieldMax,
    values,
    iconName,
  },
  parentIdentifier,
  index,
  fieldsCount,
  onChange,
  disabled,
  width,
}) => {
  const commonProps = useMemo(
    () => ({
      // TODO we might get rid of .replaceAll(".", ","), when Pentalog API will provide a small patch
      name: `${parentIdentifier}/#${fieldKey}/#${fieldType}`.replaceAll(
        ".",
        ",",
      ),
      label: (
        <div
          className={cx("d-flex align-items-center fs-md", s.radioButtonsGroup)}
        >
          {iconName && (
            <Icon
              className="icon-32 me-2"
              prefix="trox"
              iconName={iconName.toLowerCase()}
            />
          )}
          {title}
        </div>
      ),
      key: fieldKey,
      disabled,
    }),
    [parentIdentifier, fieldKey, fieldType, iconName, title, disabled],
  );

  const inputType = useMemo(
    () => `${fieldInputType}_${fieldType}`,
    [fieldInputType, fieldType],
  );

  return (
    <>
      {inputType === "input_string" && (
        <>
          {fieldMax > 100 ? (
            <Field
              component={TextInput}
              type="textarea"
              placeholder={fieldDefaultValue}
              maxLength={fieldMax}
              rows={Math.ceil(fieldMax / 150)} // 150 symbols approximately fill one row
              className="d-flex flex-grow-1"
              wrapperClassName="w-100 position-relative"
              {...commonProps}
            />
          ) : (
            <Field
              component={TextInput}
              wrapperClassName="w-100"
              data-recording-disable
              maxLength={fieldMax}
              placeholder={fieldDefaultValue}
              {...commonProps}
            />
          )}
        </>
      )}
      {inputType === "input_int" && (
        <Field
          component={FormikNumberInput}
          max={fieldMax || Infinity}
          min={fieldMin || 0}
          isMaxTitleShown={true}
          onChange={onChange}
          classNames={cx("mb-3", {
            "border-end":
              fieldsCount > 1 &&
              !(index % 2) &&
              fieldsCount !== index &&
              width > 450,
            "w-50": width > 450,
            "w-100": width <= 450,
            "px-3": fieldsCount > 1 && index % 2 && width > 450,
          })}
          {...commonProps}
        />
      )}
      {inputType === "radiobutton_bool" && (
        <Field
          component={RadioInput}
          classNames="d-flex align-items-center me-3 gap-2"
          label={commonProps.label}
          name={`${parentIdentifier}/#radiobutton`.replaceAll(".", ",")}
          type="radio"
          onChange={onChange}
          disabled={disabled}
          value={commonProps.name}
        />
      )}
      {inputType === "dropdown_string" && (
        <Field
          component={FormSelect}
          wrapperClassName={cx("flex-grow-1", {
            "me-3": !(index % 2),
            "ms-3": index % 2,
          })}
          data-recording-disable={true}
          {...commonProps}
          name={`${parentIdentifier}/#${fieldKey}/#dropdown`.replaceAll(
            ".",
            ",",
          )}
          options={values?.map((item) => ({
            value: item.fieldKey,
            label: item.fieldValue,
          }))}
        />
      )}
      {inputType === "checkbox_bool" && (
        <Field
          component={CheckboxInput}
          classNames={cx("d-flex align-items-center", s.formCheck)}
          type="checkbox"
          onChange={onChange}
          {...commonProps}
        />
      )}
    </>
  );
};
